class KitBuilderModeButtons extends HTMLElement {
  constructor() {
    super();
    this.handleModeClick = this.handleModeClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleModeClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleModeClick);
  }

  /**
   * Handles the mode click event.
   * @param {Event} event - The event.
   */
  handleModeClick(event) {
    if (!(event.target instanceof HTMLElement)) return;

    const button = event.target.closest("button");
    if (!button) return;

    // Get the mode from a data attribute on the button
    const newMode = button.dataset.mode;
    if (!newMode) return;

    // Dispatch a Custom Event to notify the parent
    this.dispatchEvent(
      new CustomEvent("modechange", {
        detail: { mode: newMode },
        bubbles: true,
        composed: true,
      }),
    );

    this.updateActiveButton(button);
  }

  /**
   * Updates the active button.
   * @param {HTMLElement} activeButton - The active button.
   */
  updateActiveButton(activeButton) {
    this.querySelectorAll("button").forEach((btn) => {
      btn.classList.remove("active");
    });
    activeButton.classList.add("active");
  }
}

customElements.define("kit-builder-mode-buttons", KitBuilderModeButtons);
